import React from "react";
import { Button, Image } from "react-bootstrap";
import ExpertBio from "./ExpertBio";
import { adminExpertProfileUrl } from "./expertProfile";

const AVATAR_SIZE = 48;

// Single row in the ExpertPicker search results. Renders a circular profile
// image on the left (top-aligned with the name), name + optional title /
// company line + bio snippet in the middle, and on the right a small
// de-emphasised semantic-distance label above the "+" Add button.
//
// Edge-to-edge: the row carries no left/right padding from a parent — the
// popover's outer frame is the only visual edge, and adjacent rows are
// separated by a single bottom border.
//
// The "Name match" badge is gone (redundant with the active tab).
export default function ExpertResultRow({ expert, onAdd, atMax }) {
  const distanceLabel = expert.semantic_distance != null ? expert.semantic_distance.toFixed(2) : null;
  const profileUrl = adminExpertProfileUrl(expert);

  return (
    <div className="d-flex align-items-start gap-3 p-3 border-bottom">
      <Image
        roundedCircle
        src={expert.profile_image_url}
        alt=""
        style={{
          width: `${AVATAR_SIZE}px`,
          height: `${AVATAR_SIZE}px`,
          objectFit: "cover",
          flexShrink: 0,
        }}
      />
      <div className="flex-grow-1" style={{ minWidth: 0 }}>
        <div className="d-flex align-items-baseline gap-2 flex-wrap">
          <strong>
            {profileUrl ? (
              <a href={profileUrl} target="_blank" rel="noreferrer">
                {expert.name}
              </a>
            ) : (
              expert.name
            )}
          </strong>
          {expert.title && expert.company && (
            <span className="text-muted small">
              {expert.title} · {expert.company}
            </span>
          )}
        </div>
        <ExpertBio description={expert.description} />
      </div>
      <div className="d-flex flex-column align-items-end gap-2">
        {expert.match_type === "semantic" && distanceLabel && (
          <span className="text-muted" style={{ fontSize: "0.7rem" }} title="Semantic distance">
            {distanceLabel}
          </span>
        )}
        <Button
          size="sm"
          variant="outline-primary"
          onClick={() => onAdd(expert)}
          disabled={atMax}
          title={atMax ? "Maximum experts already selected" : `Add ${expert.name}`}
          aria-label={`Add ${expert.name}`}
        >
          <i className="fa-solid fa-plus" aria-hidden="true" />
        </Button>
      </div>
    </div>
  );
}
